/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const HEADING_LEVEL = 2;
export const DATE_PICKER_FORMAT_OPTIONS = { dateStyle: "full" };
//# sourceMappingURL=resources.js.map
